module.exports = __webpack_public_path__ + "img/ic-phone.cc23fe0f.svg";